import type { ReactNode } from "react";

/**
 * AuthShell — shared chrome for sign-in / pending / error screens. Same retro
 * instrument aesthetic as the ops console, centered card on the dark stage.
 */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div id="viewport" className="vp-fluid">
      <div className="auth-stage">
        <div className="auth-card panel">
          <span className="corner tl" />
          <span className="corner tr" />
          <span className="corner bl" />
          <span className="corner br" />
          <div className="auth-brand">
            <div className="sigil" />
            <div>
              <div className="name">EARLYWIRE</div>
              <div className="sub">OSINT Signal Desk</div>
            </div>
          </div>
          <div className="auth-head">
            <div className="ph-label">{title}</div>
            {subtitle && <div className="auth-sub">{subtitle}</div>}
          </div>
          {children}
        </div>
        <div className="tex grain" />
        <div className="tex scan" />
        <div className="tex vign" />
      </div>
    </div>
  );
}
